var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon",attrs:{"width":_vm.getIconWidth(),"height":_vm.getIconWidth()}},[_c('use',{attrs:{"xlink:href":_vm.iconPath + _vm.type}})])
}
var staticRenderFns = []

export { render, staticRenderFns }